import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

export function apiUrlInterceptorFn(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
    // clone request and replace 'http://' with 'https://' at the same time
    let editReq = req.clone();
    const url = `${environment.apiUrl}${req.url.replace('api/', '/api/')}`;

    if (req.url.includes('api/')) {
        editReq = req.clone({ url });
    }
    return next(editReq);
}
